module.exports = __webpack_public_path__ + "static/media/02.29355bf0.jpg";